import React, { useRef, useState, useEffect } from "react";
import { string, shape, object } from "prop-types";
import get from "lodash/get";
import { useDispatch } from "react-redux";
import { getCollection } from "../../helper/api";
import { setLoading } from "../../../components/store/actions";
import useDevice from "../../helper/custom-hook/useDevice";
import InstagramCard from "../../molecules/instagram-card";
import Pagination from "../../molecules/pagination";
import ShareCollection from "../../molecules/share-collection";

import "./instagram-page.m.css";
import Share from "../../atoms/other-icons/Share";
import Instagram from "../../atoms/social-media-icons/Instagram";

const InstagramSection = ({ data, initialPage }) => {
  const cardsPerPage = 20;
  const dispatch = useDispatch();
  const ref = useRef();

  const [toggleSharing, setToggleSharing] = useState(false);
  const [stories, setStories] = useState(data.collection?.items?.map((i) => i.story).slice(0, cardsPerPage) || []);
  const [page, setPage] = useState(initialPage || 1);
  const isMobile = useDevice();
  const totalCount = get(data, ["collection", "total-count"], 0);

  const loadStories = async () => {
    const offset = cardsPerPage * page;
    if (stories.length >= totalCount) return;

    dispatch(setLoading(true));
    ref.current?.scrollIntoView({ behavior: "smooth" });

    try {
      const newStories = await getCollection("instagram", offset, cardsPerPage);
      setStories((prevStories) => {
        const uniqueStories = [...prevStories, ...newStories].filter(
          (story, index, self) => index === self.findIndex((s) => s.id === story.id)
        );
        return uniqueStories;
      });
      setPage((prevPage) => prevPage + 1);
    } finally {
      dispatch(setLoading(false));
    }
  };

  const sharingHandler = () => {
    setToggleSharing(!toggleSharing);
  };

  return (
    <div className="container" styleName="wrapper">
      <div>
        <div styleName="title">
          <Instagram color="black" height={"32px"} width={"32px"} />
          <h1>{data?.section?.["display-name"] || data?.section?.name || data?.collection?.name}</h1>
          <div styleName="share-icon-wrapper">
            <button styleName="share" onClick={sharingHandler}>
              <Share color="black" />
            </button>
            <div styleName="share-options">{toggleSharing && <ShareCollection />}</div>
          </div>
        </div>
        <p>ಸುದ್ದಿ/ಲೇಖನ ಓದಲು ಚಿತ್ರದ ಮೇಲೆ ಟ್ಯಾಪ್ ಮಾಡಿ.</p>

        <div className={isMobile ? "hide-desktop" : "hide-mobile"}>
          <div styleName="cards-wrapper">
            {stories.map((story, index) => (
              <InstagramCard story={story} key={story.id || index} />
            ))}
          </div>
        </div>

        {totalCount > stories.length && (
          <Pagination
            loadMoreStories={loadStories}
            totalItems={totalCount}
            perPage={cardsPerPage}
            initialPage={initialPage}
          />
        )}
      </div>
    </div>
  );
};

InstagramSection.propTypes = {
  data: shape({
    collection: object,
    section: string
  }),
  initialPage: string
};

export { InstagramSection };
